"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _buoyTheme = require("buoy-theme");

var _buoyTheme2 = _interopRequireDefault(_buoyTheme);

var _IconContainer = require("./IconContainer");

var _IconContainer2 = _interopRequireDefault(_IconContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AppIcon = function AppIcon(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(
    _IconContainer2.default,
    props,
    _react2.default.createElement(
      "svg",
      {
        width: "14px",
        height: "14px",
        viewBox: "0 0 14 14",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      },
      _react2.default.createElement(
        "g",
        {
          id: "190701",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        },
        _react2.default.createElement(
          "g",
          {
            id: "2_NYT-Dashboard-D",
            transform: "translate(-106.000000, -3223.000000)",
            stroke: _buoyTheme2.default.colors[props.color],
            strokeWidth: "1.25"
          },
          _react2.default.createElement(
            "g",
            { id: "Group-8", transform: "translate(107.000000, 3224.000000)" },
            _react2.default.createElement("rect", { id: "Rectangle-path", x: "0", y: "0", width: "5", height: "5" }),
            _react2.default.createElement("rect", { id: "Rectangle-path", x: "7", y: "0", width: "5", height: "5" }),
            _react2.default.createElement("rect", { id: "Rectangle-path", x: "7", y: "7", width: "5", height: "5" }),
            _react2.default.createElement("rect", { id: "Rectangle-path", x: "0", y: "7", width: "5", height: "5" })
          )
        )
      )
    )
  );
};

AppIcon.defaultProps = {
  color: "neutralDark"
};

exports.default = AppIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/AppIcon.js
// module id = 412
// module chunks = 168707334958949